import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q27',
  templateUrl: './r-q27.component.html',
  styleUrls: ['./r-q27.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ27Component implements OnInit {
  @Input() data: any;
  hgValue;
  yes_no;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  isChecked;
  messagetype;
  deviceWidth;
  user_bot = false;
  prepaid1_id;
  prepaid2_id;
  yes_src;
  no_src;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    this.hgValue = {
      value1: false,
      value2: false
    };
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.prepaid1_id = document.getElementById('Yes_mob');
      this.prepaid2_id = document.getElementById('No_mob');
    } else {
      this.prepaid1_id = document.getElementById('Yes');
      this.prepaid2_id = document.getElementById('No');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }

    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.yes_no = obj.fieldValue;
        if (!_.isEmpty(this.yes_no)) {
          this.user_bot = true;
          if (this.yes_no === 'Yes') {
            this.yes_src = 'assets/images/yes-pink.png';
            this.no_src = 'assets/images/no-gray.png';
            this.hgValue = {
              value1: true,
              value2: false
            };
            this.prepaid1_id.parentElement.parentElement.classList.add('active-select');
          } else if (this.yes_no === 'No') {
            this.yes_src = 'assets/images/yes-gray.png';
            this.no_src = 'assets/images/no-pink.png';
            this.hgValue = {
              value1: false,
              value2: true
            };
            this.prepaid2_id.parentElement.parentElement.classList.add('active-select');
          }
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        } else {
          this.yes_src = 'assets/images/yes-gray.png';
          this.no_src = 'assets/images/no-gray.png';
        }
      } else {
        this.yes_src = 'assets/images/yes-gray.png';
        this.no_src = 'assets/images/no-gray.png';
      }
    }
    this.messagetype = this.residentialService.messervicetype;
  }

  getValue(event) {
    this.yes_no = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
      if (this.yes_no === 'Yes') {
        this.yes_src = 'assets/images/yes-pink.png';
        this.no_src = 'assets/images/no-gray.png';
        this.hgValue = {
          value1: true,
          value2: false
        };
        this.prepaid1_id.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.prepaid2_id.parentElement.parentElement.classList, 'active-select')) {
          this.prepaid2_id.parentElement.parentElement.classList.remove('active-select');
        }
      } else {
        this.yes_src = 'assets/images/yes-gray.png';
        this.no_src = 'assets/images/no-pink.png';
        this.hgValue = {
          value1: false,
          value2: true
        };
        this.prepaid2_id.parentElement.parentElement.classList.add('active-select');
        if (_.contains(this.prepaid1_id.parentElement.parentElement.classList, 'active-select')) {
          this.prepaid1_id.parentElement.parentElement.classList.remove('active-select');
        }
      }
      this.user_bot = true;
    } else {
      this.yes_src = 'assets/images/yes-gray.png';
      this.no_src = 'assets/images/no-gray.png';
      this.hgValue = {
        value1: false,
        value2: false
      };
      this.yes_no = '';
      this.user_bot = false;
      if (_.contains(this.prepaid2_id.parentElement.parentElement.classList, 'active-select')) {
        this.prepaid2_id.parentElement.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.prepaid1_id.parentElement.parentElement.classList, 'active-select')) {
        this.prepaid1_id.parentElement.parentElement.classList.remove('active-select');
      }
    }
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  next() {
      if (_.isEmpty(this.yes_no)) {
      // console.log.log(this.yes_no);
      // alert('Select the Option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'yes_no', 'fieldValue': this.yes_no
    };
    this.residentialService.updateResponses(Obj);
  }
}
